import { useSelector } from "react-redux";

import { selectSubscriptionById } from "./selectors";

import type { RootState } from "../store";

export const useSubscriptionById = (
  subscriptionId: string,
): API.CardSubscription | undefined => {
  return useSelector((state: RootState) =>
    selectSubscriptionById(state, subscriptionId),
  );
};
